import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument"; // Assuming you have this function for logging

// Assuming ChampStruct has a method to convert to JSON
class ChampStruct {
  constructor(type, imgPath, content, bb, pp, ww, hh, x, y, w, h, label, page) {
    this.type = type;
    this.content = content;
    this.imgPath = imgPath;
    this.bb = bb;
    this.pp = pp;
    this.ww = ww;
    this.hh = hh;
    this.x = x;
    this.y = y;
    this.w = w;
    this.h = h;
    this.label = label;
    this.page = page;
  }

  toJson() {
    return {
      type: this.type,
      content: this.content,
      imgPath: this.imgPath,
      bb: this.bb,
      pp: this.pp,
      ww: this.ww,
      hh: this.hh,
      x: this.x,
      y: this.y,
      w: this.w,
      h: this.h,
      label: this.label,
      page: this.page,
    };
  }
}

const sign = async (
  champs,
  height,
  width,
  urlpdf,
  token,
  folderid,
  docid,
  overrideId,
  prefix,
  fileName = null,
  forDPE = false,
  consentGiven = false
) => {
  const url = prefix + `hexasign/folders/${folderid}/documents/${docid}/sign`;
  // Modify Champs types and content as per the original logic

  champs.forEach((champ) => {
    if (champ.type === "Initiales") {
      champ.type = "Signature";
    } else if (champ.type === "Coche") {
      champ.type = "Tampon";
      champ.ww = 20;
      champ.w = 20;
      champ.hh = 20;
      champ.h = 20;
      champ.content =
        champ.content === "true"
          ? "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochetrue.png?alt=media&token=54b36cc7-13e9-4a07-8edb-dd87705ca982"
          : "https://firebasestorage.googleapis.com/v0/b/foundry-2dlu01.appspot.com/o/persistent%2Fcochefalse.png?alt=media&token=74043f9c-b3fe-450f-b813-8c5e48a70af2";
    }
  });

  champs = champs.map((champ) =>
    champ instanceof ChampStruct
      ? champ
      : new ChampStruct(
          champ.type,
          champ.imgPath,
          champ.content,
          champ.bb,
          champ.pp,
          champ.ww,
          champ.hh,
          champ.x,
          champ.y,
          champ.w,
          champ.h,
          champ.label,
          champ.page
        )
  );

  const fields = champs.map((champ) => champ.toJson());

  // Request body
  const body = {
    pdf: urlpdf,
    fields: fields,
    target_height: height,
    target_width: width,
    overrideId: overrideId,
    filename: fileName,
    forDPE: forDPE,
    consentGiven: consentGiven,
  };

  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  try {
    let start = new Date();
    // Send POST request using fetch
    const response = await fetch(url, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body),
    });

    const auth = getAuthCentral();
    const currentUser = auth.currentUser;

    if (!currentUser) {
      console.error("User not logged in");
      return "";
    }

    const db = getFirestore();
    const userRef = doc(db, "user", currentUser.uid);
    const userSnapshot = await getDoc(checkDB(userRef));
    const org_id = userSnapshot.get("org_id");
    let end = new Date();
    let time = end - start;
    // Log the request and response
    await addLogDocument(
      url,
      prefix,
      userRef, // Log userRef ID
      org_id,
      response.status, // Status code
      "", // folderid
      "", // docid
      JSON.stringify(body), // request body as string
      response.statusText,
      "POST",
      time
    );

    // Check response
    if (response.ok) {
      const jsonResponse = await response.json();
    } else {
      console.error(`Failed to send request: ${response.status}`);
      return "";
    }
  } catch (error) {
    console.error(`Exception occurred: ${error.message}`);
    throw new Error(error);
  }
};

export default sign;
